import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output, Self, input, model } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';

import { FormControlPipe } from '@shared/pipe';
import { IFormCustomClass } from '@data/schema';

@Component({
    selector: 'app-switch-input',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormControlPipe],
    templateUrl: './switch-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchInputComponent implements ControlValueAccessor {
    label = input.required<string>();
    checked = model<boolean>(false);
    testAutomationSelectorName = input<string>();
    customClasses = input<IFormCustomClass>({
        formGroup: 'mb-3 d-flex justify-content-between align-items-center gap-2',
        label: 'form-label fw-medium mb-0',
        input: '',
    });

    readonly type = 'checkbox';

    @Output() inputValueChangeEvent = new EventEmitter<boolean>();

    constructor(@Self() public ngControl: NgControl) {
        this.ngControl.valueAccessor = this;
    }

    writeValue(obj: any): void {
        this.setChecked(!!obj);
    }

    registerOnChange(_fn: any): void {}
    registerOnTouched(_fn: any): void {}

    handleCheckboxChange(event: Event) {
        const target = event.target as HTMLInputElement;
        const currentValue = this.checked();
        this.setChecked(target.checked);
        this.ngControl.control?.setValue(this.checked());
        if (target.checked !== currentValue) {
            this.inputValueChangeEvent.emit(target.checked);
        }
    }

    private setChecked(checked: boolean) {
        if (checked !== this.checked()) {
            this.checked.set(checked);
        }
    }
}
